var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{attrs:{"align":"center"}},[_vm._v("Good Bye")])])
}]

export { render, staticRenderFns }